import React, { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";

const team = [
  {
    name: "Ahmed Hmada Kamal",
    track: "FullStack Developer",
    sub: "MERN Stack",
    image: "/Team/AhmedHmada2.jpeg",
    color: "#3b82f6", // Blue
  },
  {
    name: "Osama Ashraf Yahya",
    track: "Backend Developer",
    sub: "Node.js Core",
    image: "/Team/osama.jpeg",
    color: "#10b981", // Emerald
  },
  {
    name: "Mohamed M. Fouad",
    track: "Backend Developer",
    sub: "Node.js Core",
    image: "/Team/Fouad.jpeg",
    color: "#10b981",
  },
  {
    name: "Ahmed Ashraf Taha",
    track: "UI/UX Designer",
    sub: "Visual Systems",
    image: "/Team/AhmedAshraf.jpeg",
    color: "#f43f5e", // Rose
  },
  {
    name: "Mohamed A. Shappan",
    track: "AI Engineer",
    sub: "Machine Learning",
    image: "/Team/Mohamed_A_Shappan.jpeg",
    color: "#8b5cf6", // Violet
  },
];

// --- 3D Card Component ---
const HighEndCard = ({ member }) => {
  const ref = useRef(null);

  // إحداثيات الماوس
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  // فيزياء الحركة (عشان النعومة)
  const mouseX = useSpring(x, { stiffness: 500, damping: 50 });
  const mouseY = useSpring(y, { stiffness: 500, damping: 50 });

  // تحويل حركة الماوس لدرجات ميلان (Rotation)
  const rotateX = useTransform(mouseY, [-0.5, 0.5], ["15deg", "-15deg"]);
  const rotateY = useTransform(mouseX, [-0.5, 0.5], ["-15deg", "15deg"]);

  // لمعة الإضاءة (Glare) بتتحرك عكس الكارت
  const glareX = useTransform(mouseX, [-0.5, 0.5], ["0%", "100%"]);
  const glareY = useTransform(mouseY, [-0.5, 0.5], ["0%", "100%"]);

  function onMouseMove(e) {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();

    const width = rect.width;
    const height = rect.height;

    const mouseXFromCenter = e.clientX - rect.left - width / 2;
    const mouseYFromCenter = e.clientY - rect.top - height / 2;

    // بنحول القيم لنسبة من -0.5 لـ 0.5
    x.set(mouseXFromCenter / width);
    y.set(mouseYFromCenter / height);
  }

  function onMouseLeave() {
    x.set(0);
    y.set(0);
  }

  return (
    <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-5 d-flex justify-content-center perspective-container">
      <motion.div
        ref={ref}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        style={{
          rotateX,
          rotateY,
          transformStyle: "preserve-3d", // السحر كله هنا
          perspective: 1000,
        }}
        className="position-relative w-100"
      >
        {/* جسم الكارت */}
        <div
          className="position-relative rounded-4 overflow-hidden border border-white border-opacity-10 shadow-lg"
          style={{
            minHeight: "420px",
            background: "linear-gradient(145deg, rgba(20,20,23,0.9) 0%, rgba(10,10,12,0.95) 100%)",
            backdropFilter: "blur(20px)",
            transform: "translateZ(0)", // Hardware Acceleration
          }}
        >
          {/* Glare Effect Overlay */}
          <motion.div
            className="position-absolute w-100 h-100 pe-none"
            style={{
              background: `radial-gradient(circle at ${glareX} ${glareY}, rgba(255,255,255,0.15), transparent 80%)`,
              zIndex: 10,
              opacity: 0.6,
            }}
          />

          {/* محتوى الكارت (طاير فوق الخلفية) */}
          <div
            className="d-flex flex-column align-items-center h-100 p-4 pt-5"
            style={{ transform: "translateZ(50px)" }} // بيطلع لقدام 50 بيكسل
          >
            {/* دائرة الخلفية الملونة */}
            <div
              className="position-absolute rounded-circle"
              style={{
                width: "200px",
                height: "200px",
                background: member.color,
                filter: "blur(80px)",
                opacity: 0.25,
                top: "-50px",
                transform: "translateZ(-20px)",
              }}
            />

            {/* الصورة */}
            <div
              className="position-relative mb-4"
              style={{ transform: "translateZ(30px)" }}
            >
              <div
                className="rounded-circle overflow-hidden p-1 bg-gradient-to-b from-white to-transparent"
                style={{
                  width: "140px",
                  height: "140px",
                  background: `linear-gradient(180deg, ${member.color}, transparent)`,
                }}
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-100 h-100 rounded-circle object-fit-cover bg-dark"
                  style={{ border: "4px solid #0f0f11" }}
                />
              </div>
              
              {/* Badge صغير */}
              <div 
                className="position-absolute bottom-0 end-0 rounded-circle d-flex align-items-center justify-content-center text-white shadow"
                style={{ 
                    width: '35px', height: '35px', 
                    background: '#0f0f11', 
                    border: `2px solid ${member.color}`,
                    fontSize: '12px'
                }}
              >
                ★
              </div>
            </div>

            {/* النصوص */}
            <div className="text-center" style={{ transform: "translateZ(20px)" }}>
              <h4 className="text-white fw-bold mb-1 letter-spacing-1">{member.name}</h4>
              <p className="text-white-50 mb-3 small text-uppercase fw-semibold" style={{ letterSpacing: "2px" }}>
                {member.track}
              </p>
              
              {/* Chip للتفاصيل */}
              <span 
                className="px-3 py-2 rounded-3 text-white fw-light small"
                style={{ 
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    color: member.color
                }}
              >
                {member.sub}
              </span>
            </div>

            {/* Social Placeholder */}
            <div className="mt-auto d-flex gap-3 pt-4 opacity-50">
                {[1,2,3].map(i => (
                    <div key={i} className="rounded-circle bg-white" style={{width: '8px', height: '8px'}}></div>
                ))}
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default function OurTeam3D() {
  return (
    <section
      className="position-relative w-100 overflow-hidden"
      style={{
        background: "#050505", // أسود صريح للفخامة
        minHeight: "100vh",
        padding: "100px 0",
      }}
    >
      {/* Mesh Gradient Background */}
      <div 
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
            background: `
                radial-gradient(at 0% 0%, hsla(253,16%,7%,1) 0, transparent 50%), 
                radial-gradient(at 50% 0%, hsla(225,39%,30%,1) 0, transparent 50%), 
                radial-gradient(at 100% 0%, hsla(339,49%,30%,1) 0, transparent 50%)
            `,
            opacity: 0.4
        }}
      ></div>

      {/* Noise Texture (بتدي ملمس سينمائي) */}
      <div 
        className="position-absolute top-0 start-0 w-100 h-100 pe-none"
        style={{
            backgroundImage: "url('https://grainy-gradients.vercel.app/noise.svg')",
            opacity: 0.05,
            filter: 'contrast(150%) brightness(1000%)'
        }}
      ></div>

      <div className="container position-relative" style={{ zIndex: 5 }}>
        <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-5 pb-3"
        >
            <h2 className="display-3 fw-bold text-white mb-2">
                Visionaries
            </h2>
            <p className="text-secondary fs-5">Building the future of CampusPulse</p>
        </motion.div>

        <div className="row justify-content-center">
          {team.map((member, index) => (
            <HighEndCard key={index} member={member} /> 
          ))}
        </div>
      </div>
    </section>
  );
}
